// extracted by mini-css-extract-plugin
export default {"root":"style_root__kHB-r","image":"style_image__JMEoT","data":"style_data__xPVOI","name":"style_name__gBSct"};